// Human-readable label for an entity kind, shown on the entity hover card so it
// says what it is (a Task vs a Role vs a Domain object) instead of leaving you
// to infer the type from an icon. Keyed by the EntityType enum string values.
const TYPE_LABELS: Record<string, string> = {
    organization: "Organization",
    stek: "Stek",
    domain: "Domain",
    product: "Product",
    role: "Role",
    process: "Process",
    task: "Task",
    gateway: "Gateway",
    event: "Event",
    flow: "Flow",
    artefact: "Document",
    artefact_group: "Document group",
    business_entity: "Domain object",
    domain_term: "Domain term",
    document: "Document",
    application: "Application",
    application_entity: "Application entity",
};

/** A display label for the entity kind, or "" for an unknown type. */
export function entityTypeLabel(entityType: string): string {
    return TYPE_LABELS[entityType] ?? "";
}
